import axios from "axios";

const client = axios.create({
  baseURL: "/api",
  timeout: 30000
});

function normalizeParams({ page, perPage } = {}) {
  const params = {};
  if (page) params.page = page;
  if (perPage) params.per_page = perPage; // API may ignore; safe to send.
  return params;
}

export async function fetchRunning({ page = 1, perPage = 10 } = {}) {
  const res = await client.get("/running", { params: normalizeParams({ page, perPage }) });
  return res.data;
}

export async function fetchClosed({ page = 1, perPage = 10 } = {}) {
  const res = await client.get("/closed", { params: normalizeParams({ page, perPage }) });
  return res.data;
}

